// The icon of each message type, for MessageBox and Notification.
import { CheckCircleIcon, InfoIcon, WarningIcon, WrongIcon } from "./icons";

export type MessageBoxType = "success" | "informative" | "warning" | "error";
export const MESSAGE_ICON = { success: CheckCircleIcon, informative: InfoIcon, warning: WarningIcon, error: WrongIcon };
